let version = require("../../../package.json").version;
export const SSO_URL =
  process.env.REACT_APP_SSO_URL ||
  // 'http://192.168.3.82:1911/v1' ||
  "http://push-sso-api.qa.esoko.com:8080/v1";
// 'http://push-sso-api.qa.esoko.com:8080/v1'

export const SSO_API =
  process.env.REACT_APP_SSO_API_URL ||
  "https://qa-sso-api.esoko.com/api/v2" ||
  "http://accounts-sso.qa.esoko.com:5050/api/v2";

export const REACT_APP_VERSION = version;
export const REACT_APP_COOKIES_DOMAIN =
  process.env.REACT_APP_COOKIES_DOMAIN || window.location.hostname;
export const REACT_APP_NODE_ENV =
  process.env.REACT_APP_NODE_ENV || "development";
export const REACT_INTERCOM_APP_ID =
  process.env.REACT_INTERCOM_APP_ID || "jxm2i8o8";
export const REACT_RECAPTCHA_SECRET_KEY =
  process.env.REACT_RECAPTCHA_SECRET_KEY ||
  "6Le2HWIUAAAAACcBS0_vW-Dxvo7yZ9pbT_tVi9FC";
export const REACT_GOOGLE_MAP_API =
  process.env.REACT_GOOGLE_MAP_API || "AIzaSyCSjXAyUEZPiaycd0AkSlYoW2byopYtdVQ";
export const REACT_RECAPTCHA_SITE_KEY =
  process.env.REACT_RECAPTCHA_SITE_KEY ||
  "6Le2HWIUAAAAAA77C0BjqJSkbarZPuT9Gfc_GGBi";
export const STORAGE_PRFX = process.env.REACT_APP_STORAGE_PREFIX || "esk_";
export const WEATHER_RECIPIENT_LIMIT =
  parseInt(process.env.REACT_APP_WEATHER_RECIPIENT_LIMIT) || 10000;
export const REACT_APP_ACCOUNT_APP_URL =
  process.env.REACT_APP_ACCOUNT_APP_URL || "http://localhost:4000";

export const MESSAGING_API_URL =
  process.env.REACT_APP_MESSAGING_API_URL ||
  "https://qa-messaging-api.esoko.com" ||
  "http://localhost:3000";

export const PEOPLE_API_URL =
  process.env.REACT_APP_PEOPLE_API_URL || "https://qa-people-api.esoko.com/v1";

export const CONTENT_API_URL =
  process.env.REACT_APP_CONTENT_API_URL ||
  "https://qa-content-api.esoko.com/api/v1";

export const MESSAGING_API_CLIENT_KEY =
  process.env.REACT_APP_MESSAGING_API_CLIENT_KEY || "8ad733e0a5";

export const MESSAGING_API_CLIENT_SECRET =
  process.env.REACT_APP_MESSAGING_API_CLIENT_SECRET ||
  "2%&LZV*BJ^*9gfo(bHqSBbUEE";

export const AMPLITUDE_API_KEY =
  process.env.REACT_APP_AMPLITUDE_API_KEY || "AMPLITUDE_API_KEY";

// Ingest-only key; Zharp stays off when it is unset
export const ZHARP_API_KEY = process.env.REACT_APP_ZHARP_API_KEY || "";
